import SignupComponent from "../../components/Auth/signup";

export default function SignupScreen(){
return <SignupComponent />
}